import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PushToGoogleTagManager } from './google-tag-manager';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const msg =
          'HTTP Error. Method: ' +
          req.method +
          '. URL: ' +
          req.url +
          '. Status: ' +
          error.status +
          '. Message: ' +
          error.message;

        PushToGoogleTagManager({
          eventName: 'js_error',
          eventType: 'http_error',
          eventValue: msg
        });

        return throwError(() => error); // rethrow so calling code still handles it
      })
    );
  }
}
